import React, { Component } from "react";
import { reduxForm, formValueSelector } from "redux-form";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { renderTextField, renderSelect } from "../../../../ReduxFormAdapters";
import { MenuItem, Typography } from "@material-ui/core";
import DateField from "../../../../Helpers/DateField";
import FieldValidationProvider from "../../../../Helpers/FieldValidator/FieldValidationProvider";
import ValidatedField from "../../../../Helpers/FieldValidator/ValidatedField";

class UserEditForm extends Component {

    static propTypes = {
        handleSubmit: PropTypes.func.isRequired
    }

    render() {
        const { working, student, handleSubmit, form, validity } = this.props;
        return (
            <FieldValidationProvider validity={validity || {}}>
                <form className="Content-form" onSubmit={handleSubmit}>
                    <ValidatedField
                        name="firstName"
                        component={renderTextField}
                        required
                        type="text"
                        label="Your First Name*"
                    />
                    <ValidatedField
                        name="lastName"
                        component={renderTextField}
                        required
                        type="text"
                        label="Your Last Name*"
                    />
                    <ValidatedField
                        name="phoneNumber"
                        component={renderTextField}
                        type="text"
                        label="Phone Number*"
                    />
                    <ValidatedField
                        name="industry"
                        component={renderSelect}
                        multiple
                        label="Industry*"
                        required
                    >
                        <MenuItem disabled value="">Select your preferable industry type</MenuItem>
                        <MenuItem value="mn">Manufacturing</MenuItem>
                        <MenuItem value="fi">Financial services</MenuItem>
                        <MenuItem value="tr">Transportation</MenuItem>
                        <MenuItem value="ed">Education</MenuItem>
                        <MenuItem value="ti">Tiertiary industry</MenuItem>
                        <MenuItem value="hc">Health care</MenuItem>
                        <MenuItem value="ht">Hospitality</MenuItem>
                        <MenuItem value="mi">Media industry</MenuItem>
                        <MenuItem value="ot">Other</MenuItem>

                    </ValidatedField>
                    <ValidatedField
                        name="creditRating"
                        component={renderSelect}
                        label="Credit rating"
                    >
                        <MenuItem value="">
                            Select credit rating
                        </MenuItem>
                        <MenuItem value="aaa">AAA (Prime)</MenuItem>
                        <MenuItem value="aa">AA (High grade)</MenuItem>
                        <MenuItem value="a">A (Upper medium grade)</MenuItem>
                        <MenuItem value="bbb">BBB (Lower medium grade)</MenuItem>
                        <MenuItem value="bb">BB (Speculative)</MenuItem>
                        <MenuItem value="b">B (Highly speculative)</MenuItem>
                        <MenuItem value="c">C (Substantial risks)</MenuItem>
                        <MenuItem value="d">D (In default)</MenuItem>
                    </ValidatedField>
                    {/*<DateField
                        name="birthday"
                        form={form}
                        label="Birthday"
                        year
                        future
                    />
                    */}
                    <ValidatedField
                        name="yourCompanyName"
                        component={renderTextField}
                        type="text"
                        label="For how many years have you been living in Finland?"
                    />
                    {/* <ValidatedField
                        name="occupation"
                        component={renderSelect}
                        multiple
                        label="Occupation"
                    >
                        <MenuItem disabled value="">{"Select those that match your current occupation"}</MenuItem>
                        <MenuItem value="work">Working</MenuItem>
                        <MenuItem value="student">Student</MenuItem>
                    </ValidatedField> */}
                    {working &&
                        <ValidatedField
                            name="workDetails"
                            component={renderTextField}
                            type="text"
                            label="Work details"
                        />
                    }
                    {student &&
                        <ValidatedField
                            name="studentDetails"
                            component={renderTextField}
                            type="text"
                            label="Study details"
                        />
                    }
                    <ValidatedField
                        name="operatingMargin"
                        component={renderSelect}
                        label="Operating margin"
                    >
                        <MenuItem value="">
                            Specify your operating margin in dollar($)
                        </MenuItem>
                        <MenuItem value="negative">Negative</MenuItem>
                        <MenuItem value="postitive">1-10000 $</MenuItem>
                        <MenuItem value="higher">10000+ $</MenuItem>
                    </ValidatedField>
                    <ValidatedField
                        name="employee"
                        component={renderSelect}
                        label="No. of employee"
                    >
                        <MenuItem value="">
                            How many employee is the workspace for?
                        </MenuItem>
                        <MenuItem value={0}>1</MenuItem>
                        <MenuItem value={1}>2</MenuItem>
                        <MenuItem value={2}>3-4</MenuItem>
                        <MenuItem value={3}>5-9</MenuItem>
                        <MenuItem value={4}>10-19</MenuItem>
                        <MenuItem value={5}>20-49</MenuItem>
                        <MenuItem value={6}>50-99</MenuItem>
                        <MenuItem value={7}>100+</MenuItem>
                    </ValidatedField>
                    <ValidatedField
                        name="currentAddress"
                        component={renderTextField}
                        type="text"
                        label="Current Address"
                    />
                    <Typography
                        variant="body1"
                        color="secondary"
                    >
                        Please write a short description about yourself below (max 50 words)
                    </Typography>
                    <ValidatedField
                        name="description"
                        component={renderTextField}
                        multiline
                        margin="normal"
                        rowsMax="3"
                        type="text"
                    />
                </form>
            </FieldValidationProvider>
        );
    }

}

UserEditForm = connect(
    (state, ownProps) => {
        const selector = formValueSelector(ownProps.form || (ownProps.landlord ? "landlordSignup" : "signup"));
        const occupation = selector(state, "occupation");
        return {
            working: occupation
                ? (Array.isArray(occupation)
                    ? occupation.includes("work")
                    : (occupation.work ? true : false))
                : false,
            student: occupation
                ? (Array.isArray(occupation)
                    ? occupation.includes("student")
                    : (occupation.student ? true : false))
                : false,
            ...ownProps
        }
    },
    dispatch => ({
        dispatch: dispatch
    })
)(UserEditForm);

export default reduxForm({
    form: "userEdit"
})(UserEditForm);